import { message, Spin, Table, Tabs } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";
import UsersStats from "./components/UsersStats";
import CampusesStats from "./components/CampusesStats";

import CampusBuggyStats from "./components/CampusBuggyStats";

function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [adminStats, setAdminStats] = useState({ stats: [], campus_users: [] });

  const navigate = useNavigate();

  const getAdminStats = async (campus) => {
    setLoading(true);
    const res = await apiRequest({
      path: apiPaths.stats + "/admin" + (campus ? `?campus=${campus}` : ""),
    });
    setLoading(false);
    if (res.error) {
      message.error(res.error_description);
      return;
    }

    setAdminStats(res);
  };

  useEffect(() => {
    getAdminStats();
  }, []);

  const ValueComponent = ({ value, type, onClick = () => {} }) => (
    <a style={{ fontWeight: "bold", color: "#F7538D" }} onClick={onClick}>{`${
      type == "cost" ? "₹" : ""
    }${value ? value.toLocaleString() : 0}`}</a>
  );

  const getPathAndKey = (type) => {
    switch (type) {
      case "users": {
        return {
          path: "/users",
          filterKey: "created",
          additionalFilters: {},
        };
      }
      case "rides": {
        return {
          path: "/rides",
          filterKey: "start_time",
          additionalFilters: {},
        };
      }
      case "amtc": {
        return {
          path: "/transactions",
          filterKey: "date_create",
          additionalFilters: {},
        };
      }
      case "debits": {
        return {
          path: "/transactions",
          filterKey: "date_create",
          additionalFilters: {},
        };
      }
      default: {
        return {};
      }
    }
  };

  const COLUMNS = [
    {
      title: "",
      dataIndex: "name",
      render: (value) => <div style={{ fontWeight: "bold" }}>{value}</div>,
    },
    {
      title: (
        <div style={{ color: "#1B55E2", fontWeight: "bold" }}>
          {moment().format("DD/MM")}
        </div>
      ),
      dataIndex: "0",
      render: (value, record) => (
        <ValueComponent
          onClicks={() => {
            let {
              path,
              filterKey,
              additionalFilters = {},
            } = getPathAndKey(record.type);
            // if (value && path)
            navigate(path, {
              state: {
                filteredValues: {
                  [filterKey]: [
                    [
                      moment().startOf("day").toString(),
                      moment().endOf("day").toString(),
                    ],
                  ],
                  ...additionalFilters,
                },
              },
            });
          }}
          type={record.type}
          value={value}
        />
      ),
    },
    {
      title: (
        <div style={{ color: "#1B55E2", fontWeight: "bold" }}>
          {moment().subtract(1, "days").format("DD/MM")}
        </div>
      ),
      dataIndex: "1",
      render: (value, record) => (
        <ValueComponent
          onClicks={() => {
            if (value)
              navigate("/users", {
                state: {
                  filteredValues: {
                    created: [[moment().startOf(), moment().endOf()]],
                  },
                },
              });
          }}
          type={record.type}
          value={value}
        />
      ),
    },
    {
      title: (
        <div style={{ color: "#1B55E2", fontWeight: "bold" }}>
          {moment().subtract(2, "days").format("DD/MM")}
        </div>
      ),
      dataIndex: "2",
      render: (value, record) => (
        <ValueComponent
          onClicks={() => {
            if (value)
              navigate("/users", {
                state: {
                  filteredValues: {
                    created: [[moment().startOf(), moment().endOf()]],
                  },
                },
              });
          }}
          type={record.type}
          value={value}
        />
      ),
    },
    {
      title: (
        <div style={{ color: "#1B55E2", fontWeight: "bold" }}>
          {moment().subtract(3, "days").format("DD/MM")}
        </div>
      ),
      dataIndex: "3",
      render: (value, record) => (
        <ValueComponent
          onClicks={() => {
            if (value)
              navigate("/users", {
                state: {
                  filteredValues: {
                    created: [[moment().startOf(), moment().endOf()]],
                  },
                },
              });
          }}
          type={record.type}
          value={value}
        />
      ),
    },
    {
      title: (
        <div style={{ color: "#1B55E2", fontWeight: "bold" }}>
          {moment().subtract(4, "days").format("DD/MM")}
        </div>
      ),
      dataIndex: "4",
      render: (value, record) => (
        <ValueComponent
          onClicks={() => {
            if (value)
              navigate("/users", {
                state: {
                  filteredValues: {
                    created: [[moment().startOf(), moment().endOf()]],
                  },
                },
              });
          }}
          type={record.type}
          value={value}
        />
      ),
    },
    {
      title: (
        <div style={{ color: "#1B55E2", fontWeight: "bold" }}>
          {moment().subtract(5, "days").format("DD/MM")}
        </div>
      ),
      dataIndex: "5",
      render: (value, record) => (
        <ValueComponent
          onClicks={() => {
            if (value)
              navigate("/users", {
                state: {
                  filteredValues: {
                    created: [[moment().startOf(), moment().endOf()]],
                  },
                },
              });
          }}
          type={record.type}
          value={value}
        />
      ),
    },
    {
      title: <div style={{ color: "#1B55E2", fontWeight: "bold" }}>7d</div>,
      dataIndex: "7d",
      render: (value, record) => (
        <ValueComponent
          onClicks={() => {
            if (value)
              navigate("/users", {
                state: {
                  filteredValues: {
                    created: [[moment().startOf(), moment().endOf()]],
                  },
                },
              });
          }}
          type={record.type}
          value={value}
        />
      ),
    },
    {
      title: <div style={{ color: "#1B55E2", fontWeight: "bold" }}>28d</div>,
      dataIndex: "28d",
      render: (value, record) => (
        <ValueComponent
          onClicks={() => {
            if (value)
              navigate("/users", {
                state: {
                  filteredValues: {
                    created: [[moment().startOf(), moment().endOf()]],
                  },
                },
              });
          }}
          type={record.type}
          value={value}
        />
      ),
    },
    {
      title: <div style={{ color: "#1B55E2", fontWeight: "bold" }}>All</div>,
      dataIndex: "total",
      render: (value, record) => (
        <ValueComponent
          onClicks={() => {
            let { path, filterKey } = getPathAndKey(record.type);
            if (value && path) navigate(path);
          }}
          type={record.type}
          value={value}
        />
      ),
    },
  ];

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <Tabs defaultActiveKey="overview">
      <Tabs.TabPane tab="Overview" key="overview">
      <div style={{ marginBottom: 25 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 15,
          }}
        >
          <div>
            <div style={{ fontSize: 20 }}>Overall Stats</div>
            <div style={{ color: "#b7b7b7" }}>
              Note: Below stats is for All Campuses
            </div>
          </div>
        </div>
        <div>
          {loading ? (
            <div>
              <Spin /> Loading stats...
            </div>
          ) : null}
          <div>
            <Table
              columns={COLUMNS}
              size="small"
              pagination={false}
              style={{ marginRight: 15, flex: 1 }}
              dataSource={adminStats.stats}
            />
          </div>
        </div>
      </div>
      <UsersStats />
      <CampusesStats />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Campus Stats" key="campus-stats">
        <CampusBuggyStats />
      </Tabs.TabPane>
      </Tabs>
    </div>
  );
}

export default Dashboard;
